import React, { memo, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
} from '@mui/material';

interface FixedShiftCloseDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<boolean>;
  isLoading: boolean;
}

/**
 * 固定シフト締切ダイアログ
 *
 * 固定シフト募集（医師の不可申告受付）を締め切り、
 * 月次ステータスを fixed_closed へ遷移させる。
 * 締切後は「固定シフト確定」で source=rule のシフトを確定できる。
 */
const FixedShiftCloseDialog: React.FC<FixedShiftCloseDialogProps> = memo(({
  open,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const handleConfirm = useCallback(async () => {
    const success = await onConfirm();
    if (success) {
      onClose();
    }
  }, [onConfirm, onClose]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>固定シフト募集を締め切りますか？</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          医師からの不可申告の受付を終了します。
          締切後は「固定シフト確定」で医師ルール由来のシフトを確定できます。
        </Typography>
        <Alert severity="warning" sx={{ mt: 1 }}>
          締切後、医師はマイシフトから不可申告できなくなります。
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          キャンセル
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {isLoading ? '締切中...' : '固定シフト募集を締め切る'}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

FixedShiftCloseDialog.displayName = 'FixedShiftCloseDialog';

export default FixedShiftCloseDialog;
